import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, TextField } from "@mui/material";

type Props = {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
};

// Text search every Configuration list gets in its filters Paper; it filters the grid as you type
export const ConfigurationSearch = ({
	value,
	onChange,
	placeholder,
}: Props) => (
	<TextField
		label="Search"
		placeholder={placeholder}
		value={value}
		onChange={(e) => onChange(e.target.value)}
		autoComplete="off"
		slotProps={{
			inputLabel: { shrink: true },
			input: {
				endAdornment: (
					<InputAdornment position="end">
						<SearchIcon />
					</InputAdornment>
				),
			},
		}}
	/>
);
